var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGiftPurple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.375 18.125A1.875 1.875 0 0 1 2.5 16.25V9.967l-.046-.008a1.564 1.564 0 0 1-1.2-1.4l-.004-.121v-1.25c0-.863.7-1.563 1.563-1.563h2.661l-.014-.02a2.797 2.797 0 0 1-.456-1.388L5 4.063a2.812 2.812 0 0 1 4.994-1.776l.006.006.006-.006a2.807 2.807 0 0 1 2.027-1.033l.155-.004a2.812 2.812 0 0 1 2.352 4.355l-.015.02h3.287c.822 0 1.496.635 1.558 1.44l.005.122v1.25c0 .74-.514 1.36-1.204 1.522l-.046.008v6.283c0 .992-.771 1.805-1.747 1.87l-.128.005H4.375zm5-8.125H3.75v6.25c0 .316.235.578.54.62l.085.005h5V10zm7.5 0h-6.25v6.875h5.625a.625.625 0 0 0 .62-.54l.005-.085V10zm-7.5-3.125H2.812a.313.313 0 0 0-.312.313v1.25c0 .172.14.312.313.312h6.562V6.875zm8.438 0h-7.188V8.75h7.188c.15 0 .276-.107.306-.25l.006-.063v-1.25a.313.313 0 0 0-.313-.312zm-10-4.375a1.563 1.563 0 0 0 0 3.125h1.562V4.062L9.37 3.94a1.563 1.563 0 0 0-1.435-1.435L7.813 2.5zm4.375 0c-.863 0-1.563.7-1.563 1.563v-.001 1.563h1.563c.821 0 1.495-.635 1.557-1.44l.005-.122c0-.863-.7-1.563-1.563-1.563z",
    fill: "#8E06BF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftPurple);
export default __webpack_public_path__ + "static/media/gift-purple.c2e05e6d3df5d1ac00e7b57d7a5336f0.svg";
export { ForwardRef as ReactComponent };